import { render } from "./UserInvitationConfirm.vue?vue&type=template&id=4623bb96"
import script from "./UserInvitationConfirm.vue?vue&type=script&lang=js"
export * from "./UserInvitationConfirm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__